<app-data-table mainTitle="Comissão Base Empresa"
                singleTitle="Comissão Base Empresa"
                routerPath="/comissao-base-empresa"
                entityPath="/comissaobaseempresa"
                [entity]="comissaoBaseEmpresa"
                [entityFilter]="entityFilter"
                [columns]="this['columns']"
                [controls]="this['controls']">
</app-data-table>
